import React, { useState, useMemo, useEffect, useRef } from "react";
import { API_BASE } from "../api/config";
import Layout from "../components/Layout";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function Logins() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ open: false, type: "add", row: null });
  const [deleteModal, setDeleteModal] = useState({ open: false, row: null });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loginTypes, setLoginTypes] = useState([]);
  const [branches, setBranches] = useState([]);
  const [courses, setCourses] = useState([]);

  // NEW: track selected login type & selected courses
  const [selectedLoginType, setSelectedLoginType] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);

  const inputRef = useRef(null);

  useEffect(() => {
    if (modal.open && inputRef.current) inputRef.current.focus();
  }, [modal.open]);

  const fetchLoginTypes = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=login_types`
      );
      setLoginTypes(await res.json());
    } catch (err) {
      console.error("Error fetching login types:", err);
    }
  };

  const fetchBranches = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches&condition=status`
      );
      setBranches(await res.json());
    } catch (err) {
      console.error("Error fetching branches:", err);
    }
  };

  const fetchCourses = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=courses`
      );
      setCourses(await res.json());
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
  };

  const fetchLogins = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=logins&transac=get`
      );
      const result = await res.json();

      const formatted = result.map((item, index) => {
        const typeObj = loginTypes.find((lt) => lt.id === item.login_type);
        const branchObj = branches.find((b) => b.name === item.branch);
        return {
          sno: item.id,
          srno: index + 1,
          login_name: item.login_name,
          login_password: item.login_password || "",
          login_type: typeObj ? typeObj.name : item.login_type,
          login_status: item.login_status === "1" ? "Active" : "Inactive",
          branch_name: branchObj ? branchObj.name : item.branch,
          raw_login_type: item.login_type,
          raw_login_status: item.login_status,
          raw_branch_name: item.branch,
          raw_course_name: item.course_name || "",
        };
      });

      setData(formatted);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching logins:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([fetchLoginTypes(), fetchBranches(), fetchCourses()]);
    };
    loadData();
  }, []);

  useEffect(() => {
    if (loginTypes.length && branches.length && courses.length) {
      fetchLogins();
    }
  }, [loginTypes, branches, courses]);

  // ❌ Removed Course column
  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "srno" },
      { Header: "Login Name", accessor: "login_name" },
      { Header: "Password", accessor: "login_password" },
      { Header: "Login Type", accessor: "login_type" },
      { Header: "Branch", accessor: "branch_name" },
      { Header: "Login Status", accessor: "login_status" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="flex gap-2">
            <button
              className="px-2 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600"
              onClick={() => {
                setModal({ open: true, type: "edit", row: row.original });
                setSelectedLoginType(row.original.raw_login_type);
                // preselect courses if editing
                if (row.original.raw_course_name) {
                  setSelectedCourses(row.original.raw_course_name.split(","));
                } else {
                  setSelectedCourses([]);
                }
              }}
            >
              Edit
            </button>
            <button
              className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={() => setDeleteModal({ open: true, row: row.original })}
            >
              Delete
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const tableInstance = useTable(
    { columns, data, initialState: { pageSize: 5 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    setGlobalFilter,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    state: { pageIndex },
  } = tableInstance;

  const { globalFilter } = state;

  const handleSubmit = async (e) => {
    if (isSubmitting) return;
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target;
    const login_name = form.login_name.value;
    const login_type = form.login_type.value;
    const login_status = form.login_status.value;
    const login_password = form.login_password.value;
    const branch = form.branch_name.value;

    // join selected courses as comma-separated string
    const course =
      login_type === "5" ? selectedCourses.join(",") : "";

    const payload = {
      login_name,
      login_type,
      login_status,
      login_password,
      branch,
      course,
    };

    let transac = "insert";
    if (modal.type === "edit") {
      payload.id = modal.row.sno;
      transac = "update";
    }

    try {
      const response = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=logins&transac=${transac}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (result.status === (transac === "insert" ? "inserted" : "updated")) {
        fetchLogins();
        setModal({ open: false, type: "add", row: null });
      } else {
        alert("Error: " + result.message);
      }
    } catch (err) {
      console.error("Error submitting login:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    const payload = {
      key: "dzital_key",
      pswd: "Hibujji@123",
      table: "logins",
      id: deleteModal.row.sno,
      transac: "delete",
    };
    try {
      const response = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=logins&transac=delete`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (result.status === "deleted") {
        fetchLogins();
        setDeleteModal({ open: false, row: null });
      } else {
        alert("Error deleting login: " + result.message);
      }
    } catch (err) {
      console.error("Error deleting login:", err);
    }
  };

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Logins");
    XLSX.writeFile(wb, "logins.xlsx");
  };

  const exportCSV = () => {
    const csvContent = [
      columns.map((c) => c.Header).join(","),
      ...data.map((r) => columns.map((c) => r[c.accessor] || "").join(",")),
    ].join("\n");
    saveAs(
      new Blob([csvContent], { type: "text/csv;charset=utf-8;" }),
      "logins.csv"
    );
  };

  const exportJSON = () =>
    saveAs(
      new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }),
      "logins.json"
    );

  
  const exportPDF = () => {
  const doc = new jsPDF();
  doc.text("Logins Table", 20, 10);

  autoTable(doc, {
    head: [columns.filter((c) => c.accessor).map((c) => c.Header)],
    body: data.map((row) => columns.filter((c) => c.accessor).map((c) => row[c.accessor])),
    startY: 20,
  });

  doc.save("logins.pdf");
};

  if (loading) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center text-white bg-gradient-to-b from-blue-900 to-black">
          <p>Loading logins...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-blue-900 to-black p-6 text-white">
        <h1 className="text-2xl font-bold mb-4">Logins</h1>

        {/* Controls */}
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          <div className="flex flex-wrap gap-2 items-center">
            <input
              type="text"
              placeholder="Search..."
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              className="p-2 border border-gray-300 rounded text-black"
            />
            <button
              onClick={exportExcel}
              className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            >
              Excel
            </button>
            <button
              onClick={exportCSV}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              CSV
            </button>
            <button
              onClick={exportPDF}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
            >
              PDF
            </button>
          </div>
          <button
            onClick={() => {
              setModal({ open: true, type: "add", row: null });
              setSelectedLoginType("");
              setSelectedCourses([]);
            }}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Add
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto bg-white bg-opacity-10 rounded">
          <table {...getTableProps()} className="min-w-full border border-gray-300">
            <thead className="bg-gray-200 bg-opacity-20 text-white">
              {headerGroups.map((hg) => (
                <tr {...hg.getHeaderGroupProps()}>
                  {hg.headers.map((col) => (
                    <th
                      {...col.getHeaderProps(col.getSortByToggleProps())}
                      className="px-4 py-2 border cursor-pointer"
                    >
                      {col.render("Header")}
                      <span>
                        {col.isSorted
                          ? col.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="hover:bg-gray-100 hover:bg-opacity-20"
                  >
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} className="px-4 py-2 border">
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-2 flex items-center gap-2">
          <button
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            className="px-2 py-1 bg-gray-300 rounded"
          >
            {"<<"}
          </button>
          <button
            onClick={previousPage}
            disabled={!canPreviousPage}
            className="px-2 py-1 bg-gray-300 rounded"
          >
            Previous
          </button>
          <span>
            Page {pageIndex + 1} of {pageOptions.length}
          </span>
          <button
            onClick={nextPage}
            disabled={!canNextPage}
            className="px-2 py-1 bg-gray-300 rounded"
          >
            Next
          </button>
          <button
            onClick={() => gotoPage(pageOptions.length - 1)}
            disabled={!canNextPage}
            className="px-2 py-1 bg-gray-300 rounded"
          >
            {">>"}
          </button>
        </div>

        {/* Add/Edit Modal */}
        {modal.open && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white bg-opacity-95 p-6 rounded shadow-md w-96 text-black">
              <h2 className="text-xl font-bold mb-4">
                {modal.type === "add" ? "Add Login" : "Edit Login"}
              </h2>
              <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                <input
                  type="text"
                  name="login_name"
                  placeholder="Login Name"
                  defaultValue={modal.row?.login_name || ""}
                  required
                  className="p-2 border rounded"
                  ref={inputRef}
                />
                <input
                  type="text"
                  name="login_password"
                  placeholder="Password"
                  defaultValue={modal.row?.login_password || ""}
                  required
                  className="p-2 border rounded"
                />
                <select
                  name="login_type"
                  value={selectedLoginType}
                  onChange={(e) => setSelectedLoginType(e.target.value)}
                  className="p-2 border rounded"
                  required
                >
                  <option value="">Select Login Type</option>
                  {loginTypes.map((lt) => (
                    <option key={lt.id} value={lt.id}>
                      {lt.name}
                    </option>
                  ))}
                </select>
                {/* Multi select courses if login type 5 */}
{selectedLoginType === "5" && (
  <select
    name="course_name"
    value={selectedCourses}
    onChange={(e) =>
      setSelectedCourses(
        Array.from(e.target.selectedOptions, (opt) => opt.value)
      )
    }
    className="p-2 border rounded h-10"
    required
  >
    {/* 🚫 Dummy option to force required */}
    <option value="" disabled>
      -- Select Course(s) --
    </option>

    {courses.map((c) => (
      <option key={c.id} value={c.item_name}>
        {c.item_name}
      </option>
    ))}
  </select>
)}

                <select
                  name="branch_name"
                  defaultValue={modal.row?.raw_branch_name || ""}
                  className="p-2 border rounded"
                  required
                >
                  <option value="">Select Branch</option>
                  {branches.map((b) => (
                    <option key={b.id} value={b.name}>
                      {b.name}
                    </option>
                  ))}
                </select>
                <select
                  name="login_status"
                  defaultValue={modal.row?.raw_login_status || "1"}
                  className="p-2 border rounded"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
                <div className="flex justify-end gap-2 mt-2">
                  <button
                    type="button"
                    onClick={() =>
                      setModal({ open: false, type: "add", row: null })
                    }
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`px-4 py-2 text-white rounded ${
                      isSubmitting
                        ? "bg-blue-300 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Delete Modal */}
        {deleteModal.open && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white bg-opacity-95 p-6 rounded shadow-md w-96 text-black">
              <h2 className="text-xl font-bold mb-4 text-red-600">
                Confirm Delete
              </h2>
              <p>
                Are you sure you want to delete{" "}
                <strong>{deleteModal.row.login_name}</strong>?
              </p>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                  onClick={() => setDeleteModal({ open: false, row: null })}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Logins;
